//libs
import React, { memo } from 'react';

//css
import { Container, OverlaySheet, Title, Subtitle, Button, CrossIconButton } from './styles';

//constants
import { NAV_KEY, TITLE, SUBTITLE, RESET, CANCEL, CROSS_ICON_SIZE } from './constants';

//components
import { OverlaySheetContext, SHEET_TRANSITION } from 'shared/components/OverlaySheet';
import CrossIcon from '@nykaa/ui-components/Icons/close';

interface ResetOverlaySheetProps {
  onHide: VoidFunction;
  onResetClick: VoidFunction;
}

const ResetOverlaySheet = ({ onHide, onResetClick }: ResetOverlaySheetProps) => {
  return (
    <OverlaySheet
      onHide={onHide}
      navKey={NAV_KEY}
      transitionFrom={SHEET_TRANSITION.RIGHT}
      hideOnOverlayClick
      disableNav
    >
      <OverlaySheetContext.Consumer>
        {({ doHide }) => (
          <>
            <CrossIconButton onClick={doHide}>
              <CrossIcon size={CROSS_ICON_SIZE} />
            </CrossIconButton>
            <Container>
              <Title>{TITLE}</Title>
              <Subtitle>{SUBTITLE}</Subtitle>
              <Button
                kind="primary"
                shape="default"
                size="large"
                onClick={() => {
                  onResetClick();
                  doHide();
                }}
              >
                {RESET}
              </Button>
              <Button kind="secondary" shape="default" size="large" onClick={doHide}>
                {CANCEL}
              </Button>
            </Container>
          </>
        )}
      </OverlaySheetContext.Consumer>
    </OverlaySheet>
  );
};

export default memo(ResetOverlaySheet);
